import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms'
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { InsuranceCompany } from '../model/insurance/InsuranceCompany';
import { loginInfo, MessageType } from '../model/shared/model';
import { InsuranceService } from '../services/insurance/insurance.service';
import { CommonService } from '../services/shared/common.service';
import { EnvService } from '../shared/environment-service/env.service';
 
// declare function CallLoginGeneral call from java Script;
declare function CallLoginGeneral(): any;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  form = new FormGroup({
    username: new FormControl(''),
    password: new FormControl(''),
  });
  currentYear: number;

  display = false;
  showErrorMsg: boolean = false;
  errorMsg: string = "";
  isRegionalActive: boolean = false;
isUserLogin: boolean = false;
  jordanClass = "";
  regionalClass = "";
  jordanContentClass = "";
  rejionalContentClass = "";
  userName: string;
  showChangePassword: boolean = false;
  //New
  portalName: string = "";
  loginForm: FormGroup;
  authorize: boolean = false;
  loginInfo: loginInfo = new loginInfo();
  insuranceCompanyList: InsuranceCompany[];
  oldPassword: any;
  newPassword: any;
  confirmPassword: any;
  checkMatchPassword: boolean = false;

  constructor(private formBuilder: FormBuilder, private loginService: LoginService, private cs: CommonService,
    private insuranceService: InsuranceService, public env: EnvService) { }

  ngOnInit(): void {
this.currentYear = new Date().getFullYear();
    CallLoginGeneral();
 

    this.portalName = this.env.Keys.portalName;


    this.buildForm();

  }

  async SignIn() {
   
    this.loginService.localStorageService.Clear();

    let usename = this.loginForm.controls['username'].value;
    let password = this.loginForm.controls['password'].value;

    this.loginInfo.Username = usename;
    this.loginInfo.Password = password;
    this.loginInfo.language = 1;


    await this.loginService.AuthorizedLogin(this.loginInfo).then(r => {
      if (this.loginService.isAuthorized && this.loginService.isUserLogin) {
        this.isUserLogin = this.loginService.isUserLogin;
        if (this.isUserLogin)
          this.FillInsuranceCompanies(usename);
      }
      else {
        debugger;
        this.authorize = this.loginService.isAuthorized;
        let authMessage = this.loginService.authMessage.toLowerCase();

        if (authMessage.includes(this.env.ChangePasswordMessages[0]) || authMessage.includes(this.env.ChangePasswordMessages[1]))
          this.ShowChangePassword();


        this.cs.addMessage("error", "Error", this.loginService.authMessage);
      }

    });

    //this.companiesInfo = [];
    ////this.companiesInfo.push({ id: 0, name: "Select Company" });
    //let companyId: number = 0;
    //await this.auth.getCompanies(this.loginForm.value.userName).toPromise().then(data => {
    //  if (data && data.length > 0) {
    //    Array.from(data).forEach((
    //      item => {
    //        this.companiesInfo.push(item);
    //      }));

    //    companyId = Array.from(data)[0].id;
    //    this.loginForm.value.company = Array.from(data)[0].id;
    //    this.auth.setLoggedInCoreCompany(Array.from(data)[0]);
    //  }

    //});

    //if (companyId > 0)
    //  await this.getBranches(companyId, this.loginForm.value.userName);

    //await this.auth.getLanguages(32).toPromise().then(languages => {
    //  const language: FormControl = (<any>this.loginForm).controls.language;
    //  this.languages = languages;
    //});


    //if ((this.companiesInfo && this.companiesInfo.length > 1) || (this.branchesInfo && this.branchesInfo.length > 1)) {
    //  this.loginForm.patchValue({
    //    branch: this.branchesInfo[0].id,
    //    company: this.companiesInfo[0].id,
    //    language: 1
    //  });
    //}


    //this.isAuthorized();
  }

  async ConfirmLogin() {

 
    this.loginService.localStorageService.Clear();

    let usename = this.loginForm.controls['username'].value;
    let password = this.loginForm.controls['password'].value;

    this.loginInfo.Username = usename;
    this.loginInfo.Password = password;
    this.loginInfo.language = 1;


    await this.loginService.AuthorizedLogin(this.loginInfo).then(r => {
      if (this.loginService.isAuthorized) {
      //  this.FillInsuranceCompanies(usename);
      }
      else {
        this.authorize = this.loginService.isAuthorized;
        let authMessage = this.loginService.authMessage.toLowerCase();

        this.cs.addMessage("error", "Error", this.loginService.authMessage);
      }

    });
  }


  ShowChangePassword() {
    debugger;
    let formValue = this.loginForm.value;
 
    this.userName = formValue.username

    if (formValue.username) {
      this.showChangePassword = true;
      this.newPassword = null;
      this.confirmPassword = null;
    } else {

      this.cs.pushMessage(MessageType.Error, null, "You Must Select User First");
    }

  }


  async isAuthorized() {

    // let formValue = this.loginForm.value;
    //if (formValue) {
    //  this.loginInfo.Username = formValue.userName;
    //  this.loginInfo.Password = formValue.password;
    //  this.loginInfo.CompanyId = formValue.company;
    //  this.loginInfo.language = 1;
    //  this.loginInfo.BranchId = formValue.branch;
    //  this.loginInfo.ClientIP = "";

    //  if (formValue.userName && formValue.password) {
    //    await this.auth.AuthorizedLogin(this.loginInfo).then(r => {
    //      if (this.auth.isAuthorized) {

    //        if (this.companiesInfo.length == 1 && this.branchesInfo.length == 1) {
    //          this.authorize = false;
    //          this.login();
    //        }
    //        else
    //          this.authorize = true;
    //        this.auth.setLoginSource("carenet");
    //      }
    //      else {
    //        this.authorize = this.auth.isAuthorized;
    //        let authMessage = this.auth.authMessage.toLowerCase();
    //        if (authMessage.includes(AppConfiguration.Setting().ChangePasswordMessages[0]) || authMessage.includes(AppConfiguration.Setting().ChangePasswordMessages[1]))
    //          this.ShowChangePassword(); // to change password.

    //        this.cs.addMessage("error", "Error", this.auth.authMessage);
    //      }
    //    }
    //    ).catch(error => {
    //      this.cs.addMessage("error", "Error", error.error.message);
    //    })

    //  }
    //}

  }

  //login(userData: any) {


  //  //this.loginService.loginPatient(userData).subscribe((res: any) => {
  //  //  if (res) {
  //  //    this.route.navigate(['home'])
  //  //  }
  //  //});


  //  this.showErrorMsg = false;
  //  this.errorMsg = "";

  //  this.loginService.loginPatient(userData).then(
  //    (res: any) => {

  //      if (!res.error)
  //        this.route.navigate(['home']);
  //      else {
  //        this.showErrorMsg = true;
  //        this.errorMsg = res.error.error_description;
  //      }
  //    });
  //}


  ChangePassword() {
    let formValue = this.loginForm.value;
    this.newPassword == this.confirmPassword ? null : this.cs.pushMessage(MessageType.Warn, "", "Password dose not matches");
    this.loginService.UpdatePasswod(this.oldPassword, this.newPassword, this.confirmPassword, formValue.username).subscribe(data => {
      if (!data.isError) {
        //var msg = this.languageService.translateMessage("Success", "General", "OpertaionDoneSuccessfully");
        this.cs.pushMessage(MessageType.Success, null, data.apiMessage);
        this.oldPassword = null
        this.newPassword = null
        this.confirmPassword = null
        this.showChangePassword = false;
      }
      else {
        this.cs.pushMessage(MessageType.Error, null, data.apiMessage);
      }
    });
  }


  async FillInsuranceCompanies(username) {

    await this.insuranceService.GetInsuranceCompanies(username).subscribe(data => {
      Array.from(data).forEach(
        item => {
          this.insuranceCompanyList.push(item);

        });
    });
  }


  IsValidChangePassword() {
    let IsValid = false;

    IsValid = !this.checkMatchPassword && (this.confirmPassword != null && this.confirmPassword != '') && (this.newPassword != null && this.newPassword != '')
      && (this.oldPassword != null && this.oldPassword != '')

    return IsValid
  }



  CheckMatchPassword(type) {
    this.checkMatchPassword = true;

    if (type == 1) {
      if (this.confirmPassword != null || this.confirmPassword != '')
        this.checkMatchPassword = this.newPassword == this.confirmPassword ? false : true;
    } else if (type == 2) {
      if (this.newPassword != null || this.newPassword != '')
        this.checkMatchPassword = this.newPassword == this.confirmPassword ? false : true;
    }
  }



  showDialog() {
    this.display = true
  }

  checkPass(email: string) {
    this.loginService.forgotPassword(email).subscribe(res => {
      if (res) {
      }
      this.buildForm();
    })
  }

  buildForm() {
    this.loginForm = this.formBuilder.group({
      username: ['', [
        Validators.required,

      ]],
      password: ['', [
        Validators.required,
      ]],
      grant_type: ['password', [
        Validators.required,
      ]],
      'insuranceCompany': ['']
    });
  }
  Clear() {
    // this.formRestPassword.controls["email"].setValue(null);
  }

 
}
